
var headings = [];
document.querySelectorAll('h2').forEach(heading => {
    if (!heading.classList.contains('skip-anchor')) {
        headings.push(heading);
    }
});
var anchors = [];
var block_automatic_anchors_components = document.querySelectorAll('.block-automatic-anchors');


function handle_anchors(heading, i) {
    var anchor = '';
    if (i != 0) {
        anchor = heading.textContent.replace(/\s/g, "-") + '-' + i;
    } else {
        anchor = heading.textContent.replace(/\s/g, "-");
    }
    
    if (anchors.length > 0) {
        if (anchors.includes(anchor)) {
            i++;
            handle_anchors(heading, i);
        } else {
            anchors.push(anchor);
        }
    } else {
        anchors.push(anchor);
    } 
}

// Create anchors
headings.forEach(heading => {
    handle_anchors(heading, 0);
});

// Set anchors to headings
for (let i = 0; i < headings.length; i++) {
    const heading = headings[i];

    var anchor_element = document.createElement('a');
    anchor_element.setAttribute('id', anchors[i]);
    anchor_element.setAttribute('class', 'automatic-anchors__anchor');

    heading.setAttribute('style', 'position:relative');
    heading.appendChild(anchor_element);
}

block_automatic_anchors_components.forEach(component => {
    let wrapper = component.querySelector('.automatic-anchors');

    for (let i = 0; i < anchors.length; i++) {
        const anchor = anchors[i];
        var a_element = document.createElement('a');
        a_element.setAttribute('href', '#' + anchor);
        a_element.setAttribute('class', 'automatic-anchors__link');
        a_element.textContent = headings[i].textContent;

        wrapper.appendChild(a_element);
    }
});